import { darken } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useFilterBarStyles = makeStyles<
  { hasActiveFilter: boolean; hasSearchField: boolean },
  'controls' | 'searchWrapper'
>({ name: 'FilterBar' })((theme, { hasActiveFilter, hasSearchField }, classes) => ({
  root: {
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    padding: theme.spacing(1),
    minHeight: '42px',
    borderRadius: theme.shape.borderRadiusXl,
    cursor: hasSearchField ? 'text' : 'default',
    transition: theme.transitions.create('background-color'),
    backgroundColor: hasActiveFilter ? theme.palette.action.selected : 'transparent',
    '&:hover': {
      backgroundColor: hasActiveFilter
        ? darken(theme.palette.action.selected, 0.05)
        : theme.palette.action.hover,
    },
    '&:focus-within': { backgroundColor: theme.palette.action.selected },
    [theme.breakpoints.down('md')]: {
      [`&:has(.${classes.searchWrapper}:focus-within) .${classes.controls}`]: {
        display: 'none',
      },
      [`&:has(.${classes.searchWrapper}:focus-within) .${classes.searchWrapper}`]: { flex: 1 },
    },
  },
  content: {
    flex: 1,
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0,
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'nowrap',
      overflowX: 'auto',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': { display: 'none' },
    },
  },
  controls: {
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'nowrap',
      flexShrink: 0,
    },
  },
  searchWrapper: {
    display: 'flex',
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      flexShrink: 0,
    },
  },
  clearAll: {
    flexShrink: 0,
    alignSelf: 'center',
    color: theme.palette.text.secondary,
    height: '24px',
    '&:hover': { backgroundColor: 'transparent' },
  },
}));
